import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import Pagenotfound from '../components/views/PageNotFound';
import LeadCapture from './pages/LeadCapture';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import Dashboard from './pages/Dashboard';
import Visits from './pages/Visits';
import { AppBar, Toolbar, Button, Box, Container, Typography } from '@mui/material';
import RealEstatePrivateRoute from './pages/Auth/RealEstatePrivateRoute';
import RealEstateLandingPage from './pages/RealEstateLandingPage';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  return (
        <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Real Estate
          </Typography>
          <Button color="inherit" onClick={() => navigate('/realestate/lead-capture')}>
            Lead Form
          </Button>
          <Button color="inherit" onClick={() => navigate('/realestate/dashboard')}>
            Dashboard
          </Button>
          <Button color="inherit" onClick={() => navigate('/realestate/visits')}>
            Visits
          </Button>
          <Button color="inherit" onClick={() => navigate('/')}>
            Home
          </Button>
          {localStorage.getItem("access_token") ? (
            <Button
              color="inherit"
              onClick={() => {
                localStorage.removeItem("access_token");
                navigate("/realestate/login");
              }}
            >
              Logout
            </Button>
          ) : (
            <Button color="inherit" onClick={() => navigate('/realestate/login')}>
              Login
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Box sx={{ flex: 1 }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
}


export default function RealEstateRoute() {
  return (
    <Layout>
      <Routes>
        <Route path="/realestate">
          <Route path='landing-page' element={<RealEstateLandingPage/>} />
          <Route path="lead-capture" element={<LeadCapture />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="dashboard" 
            element={
              <RealEstatePrivateRoute>
                <Dashboard />
              </RealEstatePrivateRoute>
            }
             />
          <Route path="visits" 
            element={
              <RealEstatePrivateRoute>
                <Visits />
              </RealEstatePrivateRoute>
            }
             />
          <Route path="*" element={<Pagenotfound />} />
        </Route>
      </Routes>
    </Layout>
  );
}
